/**
 * Joins an array with a normal separator and a special final separator.
 *
 * Example:
 * joinWithFinalSeparator(["A", "B", "C"])
 * -> "A, B & C"
 */
export const joinWithFinalSeparator = (
  values: string[] = [],
  separator: string = ", ",
  finalSeparator: string = " & "
) => {
  if (values.length === 0) return "";
  if (values.length === 1) return values[0];

  return values.slice(0, -1).join(separator) + finalSeparator + values.at(-1);
};
